import { createBrowserRouter, createRoutesFromElements } from "react-router";
import { RouterProvider } from "react-router/dom";

import { applicationRoutes } from "./routes";

const browserRouter = createBrowserRouter(createRoutesFromElements(applicationRoutes), {
  future: { v8_middleware: true }
});

const ApplicationRouter = () => <RouterProvider router={browserRouter} />;

export { ApplicationRouter };
